import * as React from "react";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";

export function DisplayLCEDirection({
    elcedirection,
}: {
    elcedirection: number;
}) {
    const icon =
        elcedirection === ELCEDirection.inwards
            ? EGlyphicon.import
            : EGlyphicon.export;

    const tooltip =
        elcedirection === ELCEDirection.inwards
            ? "focus: inwards"
            : "focus: outwards";

    const color =
        elcedirection === ELCEDirection.inwards
            ? `hsla(195, 100%, 79%, 1)`
            : `orange`;

    return (
        <span
            {...Style(`LCEDirectionIcon_${icon}`, {
                opacity: 0.5,
                textShadow: "0px 0px 15px silver",
                color,
            })}
            data-tip={tooltip}
        >
            <Glyphicon icon={icon} />
        </span>
    );
}

export enum ELCEDirection {
    outwards,
    inwards,
}
